import { Component, OnInit, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { UserDetailService } from 'src/app/services/user-detail.service';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.css']
})
export class MeetingsComponent implements OnInit, OnDestroy {
  isSearchDivVisible = false;

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtMeetingList: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {};

  private _colAdjustTimer: any = null;
  private _resizeObserver: any = null;
  private _windowResizeHandler: () => void = null;
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  meetingArray: any[];
  meetingType: any[];
  selectedMeeting: any = null;
  meetingDateModel: any;
  meetingIdToDelete: any;
  response: boolean;
  typeHasError: boolean = true;
  agendaDocsToUpload: Array<File>;
  indexDocsToUpload: Array<File>;
  uploadDoc: boolean = false;
  FileOrignalName: any;
  changedName: any;
  templateFileName: any;
  templateDocId = '';
  downloadSingleFile = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/';
  indexTemplateFileName: any;
  indexTemplateDocId = '';
  uploadIndexDoc: boolean = false;
  type = '';
  isBoth = true;
  isCR = false;
  isMeeting = false;
  SearchType: any = 'isBoth';
  IsSequenseMeetingNumber: any;
  addType: any;

  constructor(private meetingService: MeetingMasterService,
    private route: ActivatedRoute,
    private documentManagementMasterService: DocumentManagementMasterService,
    private router: Router,
    private alert: AlertComponent,
    private userDetail: UserDetailService,
    private commonFunction: CommonFunction,
    private renderer: Renderer2) {
    this.response = false;
  }

  ngOnInit() {
    $(document).ready(() => {
      $('#isBoth').prop('checked', true);
      this.isBoth = true;
    });
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    this.environmentSettings = environment;

    this.commonFunction.validateURL('Meetings', '');
    let searchflag = localStorage.getItem('searchmeetingflag');
    this.getMeeting();
    this.getMeetingType();
    this.meetingDateModel = null;
    this.meetingsSearch = null;


    var paramData;
    if (searchflag == 'true') {

      paramData = JSON.parse(localStorage.getItem('inputdata'));

      // Saved Modify Search date windows persist in localStorage and narrow the POST body to
      // dataTable/meeting — users then see only meetings inside that range until they widen dates.
      // Default list load should always request the full company set; users can filter again via Search.
      if (paramData && (paramData.meetingFrom || paramData.meetingTo)) {
        delete paramData.meetingFrom;
        delete paramData.meetingTo;
        localStorage.setItem('inputdata', JSON.stringify(paramData));
        this.meetingsSearchDateFrom = null;
        this.meetingsSearchDateTo = null;
      }


      if (paramData.MeetingTypeID) {
        this.selectedMeeting = paramData.MeetingTypeID;
        this.getMeetingFromType();
      }

      if (paramData._id) {
        this.meetingsSearch = paramData._id;
      }
      if (paramData.meetingFrom) {
        let dt = new Date(this.commonFunction.setFormatDate(paramData.meetingFrom))
        this.meetingsSearchDateFrom = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }


      }
      if (paramData.meetingTo) {
        let dt2 = new Date(this.commonFunction.setFormatDate(paramData.meetingTo))
        this.meetingsSearchDateTo = { month: dt2.getMonth() + 1, day: dt2.getDate(), year: dt2.getFullYear() }
      }

    }
    else {
      this.meetingsSearchDateFrom = null;
      this.meetingsSearchDateTo = null;
      paramData = {
        'MeetingTypeID': this.selectedMeeting,
        '_id': this.meetingsSearch,
        'meetingFrom': this.setDate(this.meetingsSearchDateFrom),
        'meetingTo': this.setDate(this.meetingsSearchDateTo),
        'CompanyID': ''
      }
    }
    var self = this;
    var token = localStorage.getItem('token')
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.dtOptions = {
      ajax: {
        url: environment.pssServerUrl + "dataTable/meeting/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
        type: 'post',
        data: paramData,

        dataSrc: function (result) {
           
          let newData: any[] = [];
          
          if (result && Array.isArray(result.data)) {
            newData = result.data;

            for (let i = 0; i < newData.length; i++) {
              if (newData[i].MeetType === 'Circular Resolution') {
                newData[i].MeetingTime = null;
              }
              if (newData[i].MeetType == null) {
                newData[i].MeetType = 'Meeting';
              }
            }
          } else {
            console.warn("⚠️ Unexpected API response:", result);
          }

          return newData;
        },
        headers: { "x-access-token": token, timezone: timezone },
        cache: false
      },

      columns: [{
        title: 'Meeting Type',
        width: "28%",
        render: function (data: any, type: any, full: any) {
          return full.MeetingType
        }
      },
      {
        title: 'Meeting/Circular',
        width: "15%",
        render: function (data: any, type: any, full: any) {
          return full.MeetType
        }
      },
      {
        title: 'Date',
        width: "15%",
        data: "MeetingDate",
        render: function (data: any, type: any, full: any) {
          if (type === 'display' || type === 'filter') {
            return '<span style="display:none">' + full.MeetingDate + '</span>' + self.roundDigit(new Date(full.MeetingDate).getDate()) + '-' + (new Date(full.MeetingDate).getMonth() + 1) + '-' + new Date(full.MeetingDate).getFullYear() + ''
          } else {
            return new Date(full.MeetingDate).getTime()
          }
        }
      }, {
        title: 'Number',
        data: 'MeetingNumber',
        width: "13%",
        render: function (data: any, type: any, full: any) {
          if (type === 'display' || type === 'filter') {
            return data;
          } else {
            return parseInt(data);
          }
        }
      }, {
        title: 'Time',
        width: "12%",
        render: function (data: any, type: any, full: any) {

          return full.MeetingTime
        }
      },
      {
        title: self.isPssToshowMenu('status'),
        width: self.isPssToshowMenu('width'),
        render: function (data: any, type: any, full: any) {
          if (full.IsPublished && !self.environmentSettings.PSS) {
            return "<span class='badge badge-success'>Published</span>&nbsp;";
          } else if (!self.environmentSettings.PSS) {
            return "<span class='badge badge-warning'>Not Published</span>&nbsp;";
          } else {
            return ""
          }
        }
      }, {
        title: 'Action',
        width: "10%",
        render: function (data: any, type: any, full: any) {
          if (self.commonFunction.validateModulePermitions('Meetings', 'meeting/edit?goveva=true&email=') && full.MeetType == "Meeting" || full.MeetType == null) {
            return '<div class="input-group"><button [appHasPermission]="{Url: meeting/edit?goveva=true&email=, method:put, menu: Meetings}" type="button"  update-meeting=' + full._id + ' data-type=' + full.MeetType + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-meeting=' + full._id + ' data-type=' + full.MeetType + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: meeting/edit?goveva=true&email=, method:put, menu: meeting}" type="button" delete-meeting=' + full._id + ' data-type=' + full.MeetType + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-meeting=' + full._id + ' data-type=' + full.MeetType + '></span></button></div>';
          }
          else if (full.MeetType == "Circular Resolution") {
            return '<div class="input-group"><button [appHasPermission]="{Url: meeting/addCircular/edit?goveva=true&email=, method:put, menu: Meetings}" type="button"  update-meeting=' + full._id + ' data-circular=' + full.MeetType + ' class="btn-sm btn btn-warning"><span class="fa fa-pencil"  update-meeting=' + full._id + ' data-circular=' + full.MeetType + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: meeting/addCircular/edit?goveva=true&email=, method:put, menu: meeting}" type="button" delete-meeting=' + full._id + ' data-circular=' + full.MeetType + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-meeting=' + full._id + ' data-circular=' + full.MeetType + '></span></button></div>';
          }
          else {
            return '';
          }
        }
      }
      ],
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateSaveParams: (_settings: any, data: any) => {
        if (data && data.search) {
          data.search.search = '';
        }
      },
      stateLoadParams: (_settings: any, data: any) => {
        if (data && data.search) {
          data.search.search = '';
        }
      },
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [2, 'desc'],
      //order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: true, targets: null }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Meeting List',
          title: 'Meeting List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },
        }
      ]

    }

    this.IsSequenseMeetingNumber = false;
  }

  add() {
    // var dataArray=this.dataArray
    // const routeSegments = Array.isArray(sharer) ? sharer : ['userMaster', 'upsisharer', 'sharer', 'add', sharer];

    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addMeetings'] } }],
      { relativeTo: this.route.parent }
    );
  }

  addcircular() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addCircular'] } }],
      { relativeTo: this.route.parent }
    );
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  CheckProcessType(data: any) {
    if (data == 'Meeting') {
      this.isMeeting = true;
      this.isBoth = false;
      this.isCR = false;
    } else if (data == 'CR') {
      this.isCR = true;
      this.isMeeting = false;
      this.isBoth = false;
    }
    else {
      this.isBoth = true;
      this.isMeeting = false;
      this.isCR = false;
    }
  }
  isPssToshowMenu(type) {
    if (type == 'width') {
      if (!this.environmentSettings.PSS) {
        return '20%'
      } else {
        return ''
      }
    } else {
      if (!this.environmentSettings.PSS) {
        return 'Status'
      } else {
        return ''
      }
    }

  }

  getMeeting() {
    var companyID = "5a69d939e956200fa005f2f3";
    this.meetingArray = [];
    var table = $('#meetingTable').DataTable({ destroy: true });
    table.destroy();
    var meeting = JSON.parse(localStorage.getItem('meeting'));
    var circular = JSON.parse(localStorage.getItem('circular'));
    var meetingType = JSON.parse(localStorage.getItem('test'));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));

    var companyId = JSON.parse(localStorage.getItem("companyDetails")).companyID
    this.meetingService.getMeetingList(companyId)
      .subscribe(meetingList => {
        if (meetingList.status == 0) {

          this.meetingArray = meetingList.meetingData;
        }
        this.dtTrigger.next();
      })
  }

  getMeetingsByType(meetingTypeID) {
    this.meetingService.getMeetingListByType(meetingTypeID)
      .subscribe((meetingList: any) => {
        if (meetingList.status == 0) {
          var table = $('#meetingTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }


  minDateForSearchFrom: NgbDateStruct;
  minDateForSearchTo: NgbDateStruct;
  todayDateforSearchMeeting: NgbDateStruct;
  meetingsSearchDateFrom: NgbDateStruct;
  meetingsSearchDateTo: any;
  /*  
   * On select of meeting date from in search box.
   */
  meetingDateSearchMeeting() {
    var dateObj = new Date();
    this.todayDateforSearchMeeting = { year: dateObj.getUTCFullYear(), month: dateObj.getUTCMonth() + 1, day: dateObj.getUTCDate() };
    this.minDateForSearchTo = this.meetingsSearchDateFrom;
  }


  getMeetingByParam() {
    if ((this.selectedMeeting != null && this.meetingsSearch == null) && (this.meetingsSearchDateFrom == null && this.meetingsSearchDateTo == null)) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
      this.meetingArray = [];
      this.getMeetingsByType(this.selectedMeeting);
    }
    else if ((this.selectedMeeting == null && this.meetingsSearch != null) && (this.meetingsSearchDateFrom == null && this.meetingsSearchDateTo == null)) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
      this.meetingArray = [];
      this.getMeetingByDate(this.setDate(this.meetingsSearch));
    }
    else if ((this.selectedMeeting != null && this.meetingsSearch != null) && (this.meetingsSearchDateFrom == null && this.meetingsSearchDateTo == null)) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
      this.meetingArray = [];
      this.getMeetingByMeetingTypeAndDate(this.selectedMeeting, this.meetingsSearch);
    } else if (this.meetingsSearchDateFrom != null || this.meetingsSearchDateTo != null) {
      var searchParam = {
        MeetingDateFrom: this.setDate(this.meetingsSearchDateFrom),
        MeetingDateTo: this.setDate(this.meetingsSearchDateTo),
        SelectedMeetingType: this.selectedMeeting,
        OnDate: this.setDate(this.meetingsSearch)
      }
      this.getMeetingBetweenDates(searchParam)
    } else {

    }
  }

  getMeetingBetweenDates(searchParam) {
    this.meetingService.getMeetingBetweenDates(searchParam)
      .subscribe((meetingList: any) => {
        if (meetingList.status == 0) {
          var table = $('#meetingTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }

  getMeetingType() {
    this.meetingService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingType = meetingTypeList.meetingTypeList;
          this.meetingType = this.commonFunction.sortByKey(this.meetingType, 'MeetingType');
        }
      })
  }

  meetingsSearch: any;
  meetingDateOnSelectedType: any[];
  getMeetingFromType() {
    this.meetingsSearch = null
    this.meetingsSearch = null;
    this.meetingService.getMeetingOnTypeSelect(this.selectedMeeting).subscribe((data: any) => {

      if (data.meetingData.length > 0) {
        if (data.status == 0) {
          var meetingData = data.meetingData;
          this.meetingDateOnSelectedType = [];

          meetingData.forEach(element => {
            element.meetingList.MeetingDate = new Date(element.meetingList.MeetingDate);
          });

          meetingData = _.sortBy(meetingData, function (value) {
            return new Date(value.meetingList.MeetingDate);
          });

          meetingData.forEach(element => {
            var todayDate = new Date();
            var meetingDate = element.meetingList.MeetingDate

            if (moment(todayDate).diff(moment(meetingDate).format('YYYY-MM-DD'), "days") <= 0) {
              this.meetingDateOnSelectedType.push(element);

            }
          });
        }
      } else {
        this.meetingDateOnSelectedType = []
      }
    });
  }

  getMeetingByDate(meetingDateModel) {
    this.meetingService.getMeetingByDate(meetingDateModel)
      .subscribe(meetingList => {
        if (meetingList.status == 0) {
          var table = $('#meetingTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }

  getMeetingByMeetingTypeAndDate(ID, mDate) {
    var meetingSearch = {
      MeetingTypeID: ID,
      MeetingDate: mDate
    }
    this.meetingService.getMeetingByMeetingTypeAndDate(meetingSearch)
      .subscribe((meetingList: any) => {
        if (meetingList.status == 0) {
          var table = $('#meetingTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }


  setDate(date) {
    if (date != "" && date != null) {
      return date.year + "-" + date.month + "-" + date.day;
    }
    return null;
  }

  deleteMeetingByIdToPassIntoConfirmationModal(meetingId) {
    this.meetingIdToDelete = meetingId;
    $('#deleteMeetingConfirmation').modal('toggle');
  }

  deleteMeeting() {

    this.meetingService.deleteMeeting(this.meetingIdToDelete, this.IsSequenseMeetingNumber)
      .subscribe((response: any) => {
        if (response.status == 0) {
          $('#datatableMeeting').DataTable().ajax.reload();
          if (this.addType == 0) {
            this.alert.success("Meeting deleted successfully.");
          }
          else {
            this.alert.success("Circular resolution deleted successfully.");
          }
          this.meetingIdToDelete = null;
        }
      },
        error => {
          this.meetingIdToDelete = null;
          console.log("Error Occcurred", error);
        });
  }

  onEditRedirect(meetingID) {
  }

  loadMeetingByMeetingID(meetingID) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addMeetings', 'edit', meetingID] } }],
      { relativeTo: this.route.parent });
  }

  loadCircular(meetingID) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addCircular', 'edit', meetingID] } }],
      { relativeTo: this.route.parent }
    );
  }

  clear() {
    this.response = true;
    this.isBoth = true;
    this.isCR = false;
    this.isMeeting = false;
    this.SearchType = 'isBoth';
    this.meetingDateModel = null;
    this.selectedMeeting = null;
    this.meetingsSearchDateFrom = null;
    this.meetingsSearchDateTo = null;
    this.meetingsSearch = null;
    this.meetingDateOnSelectedType = [];

    localStorage.setItem('searchmeetingflag', 'false');


    var paramData = {
      'MeetingTypeID': this.selectedMeeting,
      '_id': this.meetingsSearch,
      'meetingFrom': this.setDate(this.meetingsSearchDateFrom),
      'meetingTo': this.setDate(this.meetingsSearchDateTo),
      'CompanyID': ''
    }

    var self = this;
    var token = localStorage.getItem('token')
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    $('#datatableMeeting').DataTable({
      ajax: {
        url: environment.pssServerUrl + "dataTable/meeting/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
        type: 'post',
        data: paramData,

        dataSrc: function (result) {
          //Process result here (e.g. assign to variable)
          //You must return the result of the ajax call back to the Datatable constructor

          var newData = [];
          newData = result.data;
          for (let i = 0; i < newData.length; i++) {
            if (newData[i].MeetType == 'Circular Resolution') {
              newData[i].MeetingTime = null;
            }
            if (newData[i].MeetType == null) {
              newData[i].MeetType = 'Meeting';
            }
          }
          return result.data;

        },
        headers: { "x-access-token": token, timezone: timezone },
        cache: false
      },
      columns: [{
        title: 'Meeting Type',
        width: "30%",
        render: function (data: any, type: any, full: any) {
          return full.MeetingType
        }
      },
      {
        title: 'Meeting/Circular',
        width: "28%",
        render: function (data: any, type: any, full: any) {
          return full.MeetType
        }
      },
      {
        title: 'Date',
        width: "15%",
        render: function (data: any, type: any, full: any) {
          return '<span style="display:none">' + new Date(full.MeetingDate).getFullYear() + '' + (new Date(full.MeetingDate).getMonth() + 1) + '' + self.roundDigit(new Date(full.MeetingDate).getDate()) + '</span>' + self.roundDigit(new Date(full.MeetingDate).getDate()) + '-' + (new Date(full.MeetingDate).getMonth() + 1) + '-' + new Date(full.MeetingDate).getFullYear() + ''
        }
      }, {
        title: 'Number',
        width: "15%",
        render: function (data: any, type: any, full: any) {
          return full.MeetingNumber
        }
      }, {
        title: 'Time',
        width: "20%",
        render: function (data: any, type: any, full: any) {

          return full.MeetingTime
        }
      }, {
        title: self.isPssToshowMenu('status'),
        width: self.isPssToshowMenu('width'),
        render: function (data: any, type: any, full: any) {
          if (full.IsPublished && !self.environmentSettings.PSS) {
            return "<span class='badge badge-success'>Published</span>&nbsp;";
          } else if (!self.environmentSettings.PSS) {
            return "<span class='badge badge-warning'>Not Published</span>&nbsp;";
          } else {
            return ""
          }
        }
      }, {
        title: 'Action',
        width: "10%",
        render: function (data: any, type: any, full: any) {
          if (self.commonFunction.validateModulePermitions('Meetings', 'meeting/edit?goveva=true&email=') && full.MeetType == "Meeting" || full.MeetType == null) {
            return '<div class="input-group"><button [appHasPermission]="{Url: meeting/edit?goveva=true&email=, method:put, menu: Meetings}" type="button"  update-meeting=' + full._id + ' data-type=' + full.MeetType + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-meeting=' + full._id + ' data-type=' + full.MeetType + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: meeting/edit?goveva=true&email=, method:put, menu: meeting}" type="button" delete-meeting=' + full._id + ' data-type=' + full.MeetType + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-meeting=' + full._id + ' data-type=' + full.MeetType + '></span></button></div>';
          }
          else if (full.MeetType == "Circular Resolution") {
            return '<div class="input-group"><button [appHasPermission]="{Url: meeting/addCircular/edit?goveva=true&email=, method:put, menu: Meetings}" type="button"  update-meeting=' + full._id + ' data-circular=' + full.MeetType + ' class="btn-sm btn btn-warning"><span class="fa fa-pencil"  update-meeting=' + full._id + ' data-circular=' + full.MeetType + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: meeting/addCircular/edit?goveva=true&email=, method:put, menu: meeting}" type="button" delete-meeting=' + full._id + ' data-circular=' + full.MeetType + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-meeting=' + full._id + ' data-circular=' + full.MeetType + '></span></button></div>';
          }
          else {
            return '';
          }
        }
      },
      ],
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateSaveParams: (_settings: any, data: any) => {
        if (data && data.search) {
          data.search.search = '';
        }
      },
      stateLoadParams: (_settings: any, data: any) => {
        if (data && data.search) {
          data.search.search = '';
        }
      },
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [2, 'desc'],
      //order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: null }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Meeting List',
          title: 'Meeting List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },

          customize: function (xlsx) {

            var sheet = xlsx["xl"].worksheets['sheet1.xml'];
            $('row c[r^="B"] ', sheet).each(function (ële) {
              // Get the value and strip the non numeric characters
              var dateValue = $(this).text();
              var str = dateValue.substring(24, dateValue.length)

            });

          }

        }
      ]

    });
    this.response = false;


    $('#datatableMeeting').DataTable().ajax.reload();
  }

  searchData(val) {
    this.response = true;
    var paramData = {
      'MeetingTypeID': this.selectedMeeting,
      '_id': this.meetingsSearch,
      'meetingFrom': this.setDate(this.meetingsSearchDateFrom),
      'meetingTo': this.setDate(this.meetingsSearchDateTo),
      'CompanyID': ''
    }

    localStorage.setItem('searchmeetingflag', 'true');
    localStorage.setItem('inputdata', JSON.stringify(paramData));

    var self = this;
    var token = localStorage.getItem('token')
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    $('#datatableMeeting').DataTable({
      ajax: {
        url: environment.pssServerUrl + "dataTable/meeting/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
        type: 'post',
        data: paramData,

        dataSrc: function (result) {
          //Process result here (e.g. assign to variable)
          //You must return the result of the ajax call back to the Datatable constructor

          var newData = [];
          newData = result.data;
          for (let i = 0; i < newData.length; i++) {
            if (newData[i].MeetType == 'Circular Resolution') {
              newData[i].MeetingTime = null;
            }
            if (newData[i].MeetType == null) {
              newData[i].MeetType = 'Meeting';
            }
          }
          // return result.data;
          var filter = newData.filter(function (element) {
            if (self.isMeeting == true) {
              return element.MeetType == "Meeting" || element.MeetType == null;
            }
            if (self.isCR == true) {
              return element.MeetType == "Circular Resolution";
            }
            if (self.isBoth == true) {
              return element.MeetType == "Meeting" || element.MeetType == "Circular Resolution" || element.MeetType == null;
            }
            return true;
          })
          return newData = filter;

        },
        headers: { "x-access-token": token, timezone: timezone },
        cache: false
      },
      columns: [{
        title: 'Meeting Type',
        width: "30%",
        render: function (data: any, type: any, full: any) {
          return full.MeetingType
        }
      },
      {
        title: 'Meeting/Circular',
        width: "28%",
        render: function (data: any, type: any, full: any) {
          return full.MeetType
        }
      },
      {
        title: 'Date',
        width: "15%",
        render: function (data: any, type: any, full: any) {
          return '<span style="display:none">' + new Date(full.MeetingDate).getFullYear() + '' + (new Date(full.MeetingDate).getMonth() + 1) + '' + self.roundDigit(new Date(full.MeetingDate).getDate()) + '</span>' + self.roundDigit(new Date(full.MeetingDate).getDate()) + '-' + (new Date(full.MeetingDate).getMonth() + 1) + '-' + new Date(full.MeetingDate).getFullYear() + ''
        }
      }, {
        title: 'Number',
        width: "15%",
        render: function (data: any, type: any, full: any) {
          return full.MeetingNumber
        }
      }, {
        title: 'Time',
        width: "20%",
        render: function (data: any, type: any, full: any) {

          return full.MeetingTime
        }
      }, {
        title: self.isPssToshowMenu('status'),
        width: self.isPssToshowMenu('width'),
        render: function (data: any, type: any, full: any) {
          if (full.IsPublished && !self.environmentSettings.PSS) {
            return "<span class='badge badge-success'>Published</span>&nbsp;";
          } else if (!self.environmentSettings.PSS) {
            return "<span class='badge badge-warning'>Not Published</span>&nbsp;";
          } else {
            return ""
          }
        }
      }, {
        title: 'Action',
        width: "10%",
        render: function (data: any, type: any, full: any) {
          if (self.commonFunction.validateModulePermitions('Meetings', '/meeting/edit?goveva=true&email=') && full.MeetType == "Meeting" || full.MeetType == null) {
            return '<div class="input-group"><button [appHasPermission]="{Url: /meeting/edit?goveva=true&email=, method:put, menu: Meetings}" type="button"  update-meeting=' + full._id + ' data-type=' + full.MeetType + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-meeting=' + full._id + ' data-type=' + full.MeetType + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /meeting/edit?goveva=true&email=, method:put, menu: meeting}" type="button" delete-meeting=' + full._id + ' data-type=' + full.MeetType + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-meeting=' + full._id + ' data-type=' + full.MeetType + '></span></button></div>';
          }
          else if (full.MeetType == "Circular Resolution") {
            return '<div class="input-group"><button [appHasPermission]="{Url: /meeting/addcircular/edit?goveva=true&email=, method:put, menu: Meetings}" type="button"  update-meeting=' + full._id + ' data-circular=' + full.MeetType + ' class="btn-sm btn btn-warning"><span class="fa fa-pencil"  update-meeting=' + full._id + ' data-circular=' + full.MeetType + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /meeting/addcircular/edit?goveva=true&email=, method:put, menu: meeting}" type="button" delete-meeting=' + full._id + ' data-circular=' + full.MeetType + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-meeting=' + full._id + ' data-circular=' + full.MeetType + '></span></button></div>';
          }
          else {
            return '';
          }
        }
      }
      ],
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateSaveParams: (_settings: any, data: any) => {
        if (data && data.search) {
          data.search.search = '';
        }
      },
      stateLoadParams: (_settings: any, data: any) => {
        if (data && data.search) {
          data.search.search = '';
        }
      },
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [2, 'desc'],
      //order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: null }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Meeting List',
          title: 'Meeting List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },

          customize: function (xlsx) {

            var sheet = xlsx["xl"].worksheets['sheet1.xml'];
            $('row c[r^="B"] ', sheet).each(function (ële) {
              // Get the value and strip the non numeric characters
              var dateValue = $(this).text();
              var str = dateValue.substring(24, dateValue.length)

            });

          }

        }
      ]

    });

    $('#datatableMeeting').DataTable().ajax.reload();
    this.response = false;
  }

  roundDigit(val) {

    var str = new String(val);
    if (str.length == 1) {
      return (0 + '' + val);
    } else {
      return parseInt(val);
    }
  }

  ngAfterViewInit(): void {
    // Re-sync DataTables scrollX header whenever the container changes width
    // (triggered by sidebar open/close CSS transition as well as window resize)
    const adjustCols = () => {
      clearTimeout(this._colAdjustTimer);
      this._colAdjustTimer = setTimeout(() => {
        if (this.dtElement) {
          this.dtElement.dtInstance.then((dt: DataTables.Api) => {
            dt.columns.adjust();
          });
        }
      }, 220);
    };

    // ResizeObserver fires on any layout change to the table container
    if (typeof (window as any).ResizeObserver !== 'undefined') {
      const target = document.querySelector('.datatable-card-block') as Element;
      if (target) {
        this._resizeObserver = new (window as any).ResizeObserver(adjustCols);
        this._resizeObserver.observe(target);
      }
    }
    // window resize as fallback (covers programmatic window resizing)
    this._windowResizeHandler = adjustCols;
    window.addEventListener('resize', this._windowResizeHandler);

    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("update-meeting")) {

        if (event.target.hasAttribute("data-type") == true || event.target.hasAttribute("data-type") == null) {
          this.loadMeetingByMeetingID(event.target.getAttribute("update-meeting"));
        }
        if (event.target.hasAttribute("data-circular") == true) {
          this.loadCircular(event.target.getAttribute("update-meeting"))
        }
      }
      if (event.target.hasAttribute("delete-meeting")) {
        if (event.target.hasAttribute("data-type") == true) {
          this.addType = 0;
        }
        if (event.target.hasAttribute("data-circular") == true) {
          this.addType = 1;
        }
        this.deleteMeetingByIdToPassIntoConfirmationModal(event.target.getAttribute("delete-meeting"));
      }

    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
    if (this._windowResizeHandler) {
      window.removeEventListener('resize', this._windowResizeHandler);
    }
    clearTimeout(this._colAdjustTimer);
  }

  uploadTemplate() {
    this.uploadDoc = true;
    var company = localStorage.getItem("companyDetails");
  }

  initiateUploadAgendaDocs() {
    this.getAgendaTemplate();
    this.uploadDoc = false;
    this.uploadIndexDoc = false;
    $("#AgendaDocumentUploadTitle").html("Template For Agenda");
    $("#agendaDocxUploadDialog").modal('toggle');
  }

  agendaDocsChangeEvent(fileInput: any) {
    this.type = 'style';
    this.typeHasError = false
    var inputMime = fileInput.target.files[0].type;
    var docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    var doc = 'application/msword';
    if (inputMime == docx) {
      // || inputMime == doc
      this.agendaDocsToUpload = <Array<File>>fileInput.target.files;
    } else {
      this.typeHasError = true;
    }
    fileInput = null;
  }

  uploadAgendaDocFile() {
    var file = this.agendaDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = Date.now() + '-' + this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse: any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "DocName": documentName,
                "uploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              this.meetingService.addAgendaTemplateFile(agendaTemplateObj, JSON.parse(company).companyID)
                .subscribe((responseData: any) => {
                  if (responseData.Status == 0) {
                    $("#agendaDocxUploadDialog").modal('toggle');
                    this.templateFileName = responseData.Data.DocName;
                    this.getAgendaTemplate();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.agendaDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    })
  }

  indexDocsChangeEvent(fileInput: any) {
    this.type = 'index';
    this.indexDocsToUpload = <Array<File>>fileInput.target.files;
  }

  uploadIndexTemplate() {
    this.uploadIndexDoc = true;
    var company = localStorage.getItem("companyDetails");
  }

  uploadIndexTemplateFile() {
    var file = this.indexDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = Date.now() + '-' + this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse: any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "IndexTemplateName": documentName,
                "UploadIndexFileName": this.changedName,
                "IndexDocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              this.meetingService.addIndexTemplateFile(agendaTemplateObj, JSON.parse(company).companyID)
                .subscribe((responseData: any) => {
                  if (responseData.Status == 0) {
                    $("#agendaDocxUploadDialog").modal('toggle');
                    this.indexTemplateFileName = responseData.Data.IndexTemplateName;
                    this.getAgendaTemplate();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.indexDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    })
  }

  uploadBothTemplateFile() {
    var file = this.indexDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse: any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "IndexTemplateName": documentName,
                "UploadIndexFileName": this.changedName,
                "IndexDocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              this.meetingService.addIndexTemplateFile(agendaTemplateObj, JSON.parse(company).companyID)
                .subscribe((responseData: any) => {
                  if (responseData.Status == 0) {
                    this.indexTemplateFileName = responseData.Data.IndexTemplateName;
                    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.agendaDocsToUpload).then((result) => {
                      if (result) {
                        var documentName = this.FileOrignalName;
                        var documentManagement = {
                          "DocumentManagement": {
                            DocumentName: Date.now() + '-' + documentName,
                            DateOfDocument: new Date(),
                            Upload: this.changedName,
                            OriginalFileName: this.FileOrignalName,
                            CompletedDate: null,
                            DirectorID: null,
                            DirectorKmp: "None",
                            KMPID: null,
                            MeetingTypeID: null,
                            Overwrite: false,
                            ParentDocumentTypeID: null,
                            ParentSubDocumentTypeID: null,
                            Remarks: null
                          }
                        }
                        this.documentManagementMasterService.addDocumentManagement(documentManagement)
                          .subscribe((docResponse: any) => {
                            if (docResponse.status == 0) {
                              var addedDocumentData = docResponse.result;
                              var agendaTemplateObj = {
                                "DocName": documentName,
                                "uploadFileName": this.changedName,
                                "DocumentManagementID": addedDocumentData._id
                              }
                              var company = localStorage.getItem("companyDetails");
                              this.meetingService.addAgendaTemplateFile(agendaTemplateObj, JSON.parse(company).companyID)
                                .subscribe((responseData: any) => {
                                  if (responseData.Status == 0) {
                                    $("#agendaDocxUploadDialog").modal('toggle');
                                    this.templateFileName = responseData.Data.DocName;
                                    this.getAgendaTemplate();
                                    this.alert.success("Template Uploaded Successfully");
                                  } else {
                                    this.alert.error("Something went wrong");
                                  }
                                })
                            } else {
                              this.alert.error("Something went wrong");
                            }
                          });
                        this.agendaDocsToUpload = [];
                      } else {
                        this.alert.error("Oops, Something Went Wrong");
                      }
                    })
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.indexDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    })
  }

  uploadDocs() {
    if (this.indexDocsToUpload.length > 0 && this.agendaDocsToUpload.length > 0) {
      this.uploadBothTemplateFile();
    } else if (this.type == 'style') {
      this.uploadAgendaDocFile();
    } else if (this.type == 'index') {
      this.uploadIndexTemplateFile();
    }
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], now + '-' + files[i].name.replace(',', ''));
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = now + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  downloadFile(type) {
    var token = localStorage.getItem('token')

    if (type == 'style') {
      window.location.href = this.downloadSingleFile + this.templateDocId + "/" + token;;
    } else if (type == 'index') {
      window.location.href = this.downloadSingleFile + this.indexTemplateDocId + "/" + token;
    }

  }

  getAgendaTemplate() {
    var company = localStorage.getItem("companyDetails");
    this.meetingService.getAgendaTemplateData(JSON.parse(company).companyID).subscribe(templateRes => {
      this.templateFileName = templateRes.Data.DocName;
      this.templateDocId = templateRes.Data.DocumentManagementID;
      this.indexTemplateFileName = templateRes.Data.IndexTemplateName;
      this.indexTemplateDocId = templateRes.Data.IndexDocumentManagementID;
    })
  }
}
